// AccountDeletion.jsx
import React from "react";
import Layout from "../../components/user/Layout";

const AccountDeletion = () => {
  return (
    <Layout>
      <div className="account-deletion-policy py-22 ps-40 pe-40">
        <h3 className="d-flex justify-content-center fw-bold">
          Account Deletion Policy
        </h3>
        <p>
          Your privacy and control over your personal data are important to us.
          If you wish to delete your account on Power Trading Company, we
          provide a simple and secure process.
        </p>

        <section>
          <h5>How to Request Account Deletion</h5>
          <p>
            You can delete your account by clicking the{" "}
            <strong>"Permanently Delete Account"</strong> button below:
          </p>
          <button
            className="btn"
            style={{
              background: "#FA6400",
              color: "white",
              border: " none",
              padding: " 12px 24px",
              borderRadius: "6px",
              fontWeight: " bold",
              cursor: " pointer",
              margin: "16px 0",
            }}
          >
            Permanently Delete Account
          </button>
        </section>

        <section>
          <h5>Deletion Timeframe</h5>
          <p>
            Once you click the button, your account will be permanently deleted.
            All your personal information including name, phone number, address,
            and order history will be removed from our system.
          </p>
        </section>

        <section>
          <h5>Important Notes</h5>
          <ul>
            <li>
              This action is <strong>irreversible</strong>.
            </li>
            <li>
              Once deleted, your data <strong>cannot be recovered</strong>.
            </li>
            <li>
              Make sure to clear any remaining balance in your wallet before
              submitting a deletion request.
            </li>
          </ul>
        </section>

        <section className="thank-you">
          <p>
            Thank you for being a part of Power Trading Company. Your trust
            matters to us. 💚
          </p>
        </section>
      </div>
    </Layout>
  );
};

export default AccountDeletion;
